module.exports = __webpack_public_path__ + "static/media/declineIcon.a2e608c0.svg";